/**
Project: Voice Panel (c)
Title: Signin Interactive End 
Description: Component for Authorization check for browser signin
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Button, Flex, Text, Image } from "@fluentui/react-northstar";
import { adalConfig } from "../settings/adal-config";
import IntlTranslate from "../helpers/intl-translate";
import IntlUtil from "../helpers/intl-util";
import SippioVoicePanelLogo from "../../../assets/images/SIPPIO-VoicePanel-Logo.png";
import TokenUtil from "../helpers/token-util";
import { authenticateTokenSignin } from "../actions/identity-actions";
import { AppURLProps } from "../settings/app-urls";
import { AppConfigProps } from "../settings/app-config";
import { AuthenticationContext } from "react-adal";
import PageLoader from "../../voice-admin/pages/common/helpers/page-loader";
import ResponseUtil from "../helpers/response-util";
import { AppConstants } from "../settings/app-constants";

class SigninInteractiveEnd extends Component {
  _isMounted = false;
  _intl_ns_common = "common";
  _intl_ns_signin = "signin";
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      isErrorOccurred: false,
      errorDetails: null
      // authContext:null
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  componentDidMount() {
    this._isMounted = true;
    this.initializeSignin();
    this.setStateAsync({ authContext: new AuthenticationContext(adalConfig) });

    // setTimeout(() => {
    //   if (this.state.errorMessage) {
    //     let authContext = new AuthenticationContext(adalConfig);
    //     authContext.logOut();
    //   }
    // }, 10000);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  initializeSignin = () => {
    this.clearSigninError();
    let authContext = new AuthenticationContext(adalConfig);


    if (authContext.isCallback(window.location.hash)) {


      let requestInfo = authContext.getRequestInfo(window.location.hash);
      if (requestInfo.valid) {
        authContext.saveTokenFromHash(requestInfo); //Save the token and user information.
        let token = authContext.getCachedToken(adalConfig.clientId);
        if (token) {
          this.handleSignin(token, this.props.history);
        } else {
          let errorDetails = this.getErrorDetails(authContext);
          let errorMessage = IntlUtil.getText(
            this._intl_ns_signin,
            "notification.error.signinError"
          );
          this.setSigninError(errorMessage, errorDetails);
        }
      } else {
        let errorDetails = this.getErrorDetails(authContext);
        let errorMessage = IntlUtil.getText(
          this._intl_ns_signin,
          "notification.error.signinError"
        );
        this.setSigninError(errorMessage, errorDetails);
      }
      // }

    } else {
      let errorDetails = this.getErrorDetails(authContext);
      let errorMessage = IntlUtil.getText(
        this._intl_ns_signin,
        "notification.error.signinError"
      );
      this.setSigninError(errorMessage, errorDetails);
    }

    // Not logged in
    // return false
  };
  handleSignin = async (token, history) => {
    this.clearSigninError();
    try {
      let res = await authenticateTokenSignin(token);
      if (
        res &&
        res.status === AppConfigProps.httpStatusCode.ok &&
        res.data &&
        res.data.result &&
        res.data.result.accessToken &&
        res.data.result.refreshToken
      ) {
        await TokenUtil.setIdentityToken(
          res.data.result.accessToken,
          res.data.result.refreshToken
        );
        this.props.history.push(AppURLProps.home);
      } else {
        let errorMessage = IntlUtil.getText(
          this._intl_ns_signin,
          "notification.error.signinIssueUnknown"
        );
        this.setSigninError(errorMessage, null);
      }
    } catch (err) {
      let errorMessage = IntlUtil.getText(
        this._intl_ns_signin,
        "notification.error.signinIssueUnknown"
      );
      let errorDetails = [];
      if (err && err.status) {

        if (err.status === AppConfigProps.httpStatusCode.badRequest) {
          errorMessage = IntlUtil.getText(
            this._intl_ns_signin,
            "notification.error.signinIssueUnknown"
          );

        } else if (err.status === AppConfigProps.httpStatusCode.forbidden) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (
            primeError &&
            primeError.code === AppConstants.SIGIN_IN.FORBIDDEN_ERROR_MESSAGES.ADMIN_PRIVILEGES
          ) {
            let authContext = AuthenticationContext.prototype._singletonInstance;
            errorMessage =
              authContext._user.userName +
              ", " +
              IntlUtil.getText(
                this._intl_ns_signin,
                "notification.error.privilegeError"
              );

          } else if (primeError &&
            primeError.code === AppConstants.SIGIN_IN.FORBIDDEN_ERROR_MESSAGES.ADMIN_CONSENT) {
            errorMessage =
              IntlUtil.getText(
                this._intl_ns_signin,
                "notification.error.signinNoConsent"
              );
            if (primeError.message && primeError.message.trim().length > 0) {
              errorDetails.push(primeError.message);
              this.setStateAsync({ errorDetails: errorDetails });
            }
          } else if (primeError &&
            primeError.code === AppConstants.SIGIN_IN.FORBIDDEN_ERROR_MESSAGES.LYNC_RESOURCE) {
            errorMessage =
              IntlUtil.getText(
                this._intl_ns_signin,
                "notification.error.signinNoLync"
              );
            if (primeError.message && primeError.message.trim().length > 0) {
              errorDetails.push(primeError.message);
              this.setStateAsync({ errorDetails: errorDetails });
            }
          } else if (primeError &&
            primeError.code === AppConstants.SIGIN_IN.FORBIDDEN_ERROR_MESSAGES.SIGNIN_DIRECTORY) {
            errorMessage =
              IntlUtil.getText(
                this._intl_ns_signin,
                "notification.error.signinNoDirectory"
              );
            if (primeError.message && primeError.message.trim().length > 0) {
              errorDetails.push(primeError.message);
              this.setStateAsync({ errorDetails: errorDetails });
            }
          }
          else {
            errorMessage = IntlUtil.getText(
              this._intl_ns_signin,
              "notification.error.signinError"
            );
          }
        } else {
          errorMessage = IntlUtil.getText(
            this._intl_ns_signin,
            "notification.error.signinIssueUnknown"
          );

        }
      }

      this.setSigninError(errorMessage, errorDetails);

    }
  };


  renderErrorInfo = () => {
    let authContext = new AuthenticationContext(adalConfig);
    return (
      <Flex
        gap="gap.small"
        hAlign="center"
        vAlign="center"
        className="signin-page-wrapper"
        column
      >
        <Flex column gap="gap.large" className="signin-silent-wrapper">
          <Flex column gap="gap.medium" hAlign="center">
            <Image
              src={SippioVoicePanelLogo}
              alt={IntlUtil.getText(
                this._intl_ns_common,
                "content.voicePanelBySippio"
              )}
              title={IntlUtil.getText(
                this._intl_ns_common,
                "content.voicePanelBySippio"
              )}
            />
          </Flex>
          <Flex column gap="gap.medium" hAlign="center">
            {this.state.errorMessage ? (
              <>
                <Flex column hAlign="start">
                  <Text
                    content={IntlUtil.getText(
                      this._intl_ns_signin,
                      "content.teamsSigninInfo2"
                    )}
                    className="signin-text"
                  />
                </Flex>
                <Flex column hAlign="start">
                  <Text
                    content={this.state.errorMessage}
                    error={true}
                    className="signin-text"
                  />
                </Flex>
                {this.state.errorDetails && this.state.errorDetails.length > 0 ? (<Flex column gap="gap.small" className="signin-div">
                  {this.state.errorDetails.map(error => {
                    return (
                      <Text content={error} />)
                  })}
                </Flex>) : null}
              </>
            ) : null}
            <Button
              type="submit"
              content={
                <IntlTranslate
                  namespace={this._intl_ns_signin}
                  keyId="content.signout"
                />
              }
              primary
              className="signin-button"
              onClick={() => {
                authContext.logOut();
              }}
            />
          </Flex>
        </Flex>
      </Flex>
    );
  };

  getErrorDetails = (authContext) => {
    let errorDetails = [];
    if (authContext) {
      let requestInfo = authContext.getRequestInfo(window.location.hash);
      if (requestInfo) {
        if (requestInfo.parameters) {
          if (requestInfo.parameters.error) {
            errorDetails.push(IntlUtil.getText(
              this._intl_ns_signin,
              "content.error"
            ) + requestInfo.parameters.error);
          }
          if (requestInfo.parameters.error_subcode) {
            errorDetails.push(IntlUtil.getText(
              this._intl_ns_signin,
              "content.errorSubcode"
            ) + requestInfo.parameters.error_subcode);
          }
          if (requestInfo.parameters.error_description) {
            errorDetails.push(IntlUtil.getText(
              this._intl_ns_signin,
              "content.errorDescription"
            ) + requestInfo.parameters.error_description);
          }
        }
      }
    }
    return errorDetails;
  }

  setSigninError = async (errorMessage, errorDetails) => {
    await this.setStateAsync({
      isErrorOccurred: true,
    });
    await this.setStateAsync({ errorMessage: errorMessage });
    if (errorDetails && errorDetails.length > 0) {
      await this.setStateAsync({ errorDetails: errorDetails });

    }
  }

  clearSigninError = async () => {
    await this.setStateAsync({
      isErrorOccurred: false,
    });
    await this.setStateAsync({ errorMessage: null });
    await this.setStateAsync({ errorDetails: null });
  }

  renderLoader() {
    return (
      <div id="vpa-layout">
        <PageLoader
          status={this.state.isAppDataFetched}
          size="medium"
          labelPosition="below"
          label={IntlUtil.getText(
            this._intl_ns_common,
            "content.loadingInprogress"
          )}
          type="full-center"
        ></PageLoader>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.state.isErrorOccurred
          ? this.renderErrorInfo()
          : this.renderLoader()}
      </>
    );
  }
}

export default SigninInteractiveEnd;